export const SERVICE_DOCUMENT_URL =
  'https://form.typeform.com/to/zX4iTBc5?typeform-source=join-cloak.ecbo.io'
